<template>
    <div>
        <v-navigation-drawer
            :value="$vuetify.breakpoint.lgAndUp"
            app
            right
            :width="500"
        >
            <BasketList />
        </v-navigation-drawer>
        <v-app-bar
            app
            color="primary"
            dark
            elevate-on-scroll
            clipped-left
            height="65"
        >
            <v-app-bar-nav-icon :ripple="false" class="pl-4">
                <v-img src="@/assets/images/logo.png" width="50" :alt="`${title} Logo`" />
            </v-app-bar-nav-icon>
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-spacer />
            <v-btn v-if="canShare" @click="share" icon>
                <v-icon>mdi-share-variant</v-icon>
                <span class="d-sr-only">Share</span>
            </v-btn>
            <template v-slot:extension>
                <portal-target name="app-bar" class="v-tabs" />
            </template>
        </v-app-bar>
    </div>
</template>

<script>
import { Share } from '@capacitor/share';
import BasketList from './BasketList';

export default {
  name: 'TheHeader',

  components: { BasketList },

  data: () => ({
    title: process.env.VUE_APP_TITLE,
    canShare: false,
  }),

  async mounted() {
    const { value } = await Share.canShare();
    this.canShare = value;
  },

  methods: {
    async share() {
      try {
        await Share.share({
          title: process.env.VUE_APP_TITLE,
          url: process.env.VUE_APP_BASE_URL,
        });
      } catch (error) {
        console.error('Share action failed', error);
      }
    },
  },
};
</script>

<style lang="scss">
  .v-slide-group__prev {
    display: none !important;
  }

  .no-focus {
    &:focus,
    &:hover,
    &:active {
      &::before {
        opacity: 0 !important;
      }
    }
  }
</style>
